import fetchRequest from '@/app/_utils/fetch-request'
import { TimeoutError } from '@/app/_utils/types'

interface Params {
    slug?: string
    isPreview?: boolean
    isServerSideRequest?: boolean
}

export const fetchPageData = async ({ isPreview = false, slug, isServerSideRequest = false }: Params) => {
    try {
        const data = await fetchRequest({
            endpoint: slug ? `/pages?slug=${slug}&preview=${isPreview}` : '/pages',
            method: 'GET',
            serviceName: 'cml',
            isServerSideRequest,
        })

        return data
    } catch (error) {
        if (error instanceof TimeoutError) {
            throw error
        }
        return null
    }
}
